import { render, staticRenderFns } from "./FireSchedule.vue?vue&type=template&id=96baa8d4&"
import script from "./FireSchedule.vue?vue&type=script&lang=js&"
export * from "./FireSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports